import {
  Armchair,
  Bath,
  Bed,
  BedDouble,
  ChefHat,
  Flame,
  Fan,
  Home,
  Leaf,
  Monitor,
  Sun,
  TreePine,
  Wind,
  type LucideProps,
} from 'lucide-react';
import type { IconaZona, TipoGeneratore } from '@emacomfort/domain';

export function IconaZonaVista({ icona, ...props }: { icona: IconaZona } & LucideProps) {
  switch (icona) {
    case 'soggiorno':
      return <Armchair {...props} />;
    case 'cucina':
      return <ChefHat {...props} />;
    case 'camera':
      return <BedDouble {...props} />;
    case 'cameretta':
      return <Bed {...props} />;
    case 'bagno':
      return <Bath {...props} />;
    case 'studio':
      return <Monitor {...props} />;
    case 'veranda':
      return <Sun {...props} />;
    case 'taverna':
      return <TreePine {...props} />;
    default:
      return <Home {...props} />;
  }
}

export function IconaGeneratore({ tipo, ...props }: { tipo: TipoGeneratore } & LucideProps) {
  switch (tipo) {
    case 'POMPA_DI_CALORE':
      return <Fan {...props} />;
    case 'CALDAIA_GAS':
      return <Flame {...props} />;
    case 'STUFA_PELLET':
      return <Leaf {...props} />;
    case 'TERMOCAMINO':
      return <Flame {...props} />;
    default:
      return <Wind {...props} />;
  }
}
